export default "__VITE_ASSET__0446b112__"